import { render, staticRenderFns } from "./IndustryReport.vue?vue&type=template&id=a6f5ccce&scoped=true"
import script from "./IndustryReport.vue?vue&type=script&lang=js"
export * from "./IndustryReport.vue?vue&type=script&lang=js"
import style0 from "./IndustryReport.vue?vue&type=style&index=0&id=a6f5ccce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f5ccce",
  null
  
)

export default component.exports